import api from './../../utils/api';

export const loadSearchProcessDetail = (id) => {
  const url = `processes/view/${id}/true`;
  return api.get(url);
};
